export default __webpack_public_path__ + "static/media/tableimg.440decee.jpg";